import { render, staticRenderFns } from "./OrderData.vue?vue&type=template&id=d8488b44&scoped=true"
import script from "./OrderData.vue?vue&type=script&lang=js"
export * from "./OrderData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8488b44",
  null
  
)

export default component.exports